module.exports = __webpack_public_path__ + "img/djibouti.4c8fdca0.svg";